import { Action, Mutation } from 'vuex-module-decorators';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { SurveySessionValueModel } from '@trialcard/apigateway.models';
import { Resolve } from 'vue-di';
import { Settings } from '~/services/settings';

export interface IEligibilityData {
    eligibilityFederal?: string;
    diagnosis?: string;
    doesAgreeMarketing?: string;
}
@InjectModule({ stateFactory: true }, module)
export default class EligibilityModule extends InjectVuexModule {
    @Resolve
    public settings!: Settings;

    public eligibilityData: SurveySessionValueModel[] = [];

    public isEligible = false;

    public isMarketingOptInCheck = false;

    @Mutation
    public async updateEligibilityData(newEligibilityData: typeof EligibilityModule.prototype.eligibilityData | any) {
        this.eligibilityData = newEligibilityData;
    }

    @Mutation
    public async updateIsEligible(isEligible: boolean) {
        this.isEligible = isEligible;
    }

    @Action({ rawError: true })
    public checkPatientEligibility(eligibilityData: SurveySessionValueModel[]): boolean {
        if (localStorage.getItem('enrollmentTypePatientOrHCP') === 'HCP') {
            if (localStorage.getItem('drugNamePath') === 'eloctate') {
                const correctAnswers = [
                    +this.settings.hasBeenPrescribedAnswerYesIdHcpEloctate,
                    +this.settings.isCommerciallyInsuredAnswerYesIdHcp,
                    // +this.settings.isFederalAnswerYesIdHCP,
                    +this.settings.isFederalAnswerYesIdHCPQfitlia,
                    +this.settings.isUSResidentAnswerYesIdHcp,
                    +this.settings.marketingOptInAnswerYesIdHcp,
                    +this.settings.marketingOptInAnswerNoIdHcp,
                    +this.settings.iConsentAnswerYesIdHcp,
                ] as number[];
                if (this.isMarketingOptInCheck) {
                    correctAnswers.push(+this.settings.marketingOptInAnswerYesIdHcp);
                    correctAnswers.push(+this.settings.marketingOptInAnswerNoIdHcp);
                }
                const isEligible = eligibilityData.every(question => question.answerId && correctAnswers.includes(question.answerId));
                this.updateIsEligible(isEligible);
                return isEligible;
            } else if (localStorage.getItem('drugNamePath') === 'altuviiio') {
                const correctAnswers = [
                    +this.settings.hasBeenPrescribedAnswerYesIdHcpAltuviiio,
                    +this.settings.isCommerciallyInsuredAnswerYesIdHcp,
                    // +this.settings.isFederalAnswerYesIdHCP,
                    +this.settings.isFederalAnswerYesIdHCPQfitlia,
                    +this.settings.isUSResidentAnswerYesIdHcp,
                    +this.settings.marketingOptInAnswerYesIdHcp,
                    +this.settings.marketingOptInAnswerNoIdHcp,
                    +this.settings.iConsentAnswerYesIdHcp,
                ] as number[];
                if (this.isMarketingOptInCheck) {
                    correctAnswers.push(+this.settings.marketingOptInAnswerYesIdHcp);
                    correctAnswers.push(+this.settings.marketingOptInAnswerNoIdHcp);
                }
                const isEligible = eligibilityData.every(question => question.answerId && correctAnswers.includes(question.answerId));
                this.updateIsEligible(isEligible);
                return isEligible;
            } else if (localStorage.getItem('drugNamePath') === 'qfitlia') {
                const correctAnswers = [
                    +this.settings.hasBeenPrescribedAnswerYesIdHcpQfitlia,
                    +this.settings.isCommerciallyInsuredAnswerYesIdHcp,
                    +this.settings.isFederalAnswerYesIdHCPQfitlia,
                    +this.settings.isUSResidentAnswerYesIdHcp,
                    +this.settings.iConsentAnswerYesIdHcp,
                ] as number[];
                const isEligible = eligibilityData.every(question => question.answerId && correctAnswers.includes(question.answerId));
                this.updateIsEligible(isEligible);
                return isEligible;
            } else {
                const correctAnswers = [
                    +this.settings.hasBeenPrescribedAnswerYesIdHcpAlprolix,
                    +this.settings.isCommerciallyInsuredAnswerYesIdHcp,
                    // +this.settings.isFederalAnswerYesIdHCP,
                    +this.settings.isFederalAnswerYesIdHCPQfitlia,
                    +this.settings.isUSResidentAnswerYesIdHcp,
                    +this.settings.marketingOptInAnswerYesIdHcp,
                    +this.settings.marketingOptInAnswerNoIdHcp,
                    +this.settings.iConsentAnswerYesIdHcp,
                ] as number[];
                if (this.isMarketingOptInCheck) {
                    correctAnswers.push(+this.settings.marketingOptInAnswerYesIdHcp);
                    correctAnswers.push(+this.settings.marketingOptInAnswerNoIdHcp);
                }
                const isEligible = eligibilityData.every(question => question.answerId && correctAnswers.includes(question.answerId));
                this.updateIsEligible(isEligible);
                return isEligible;
            }
        } else if (localStorage.getItem('drugNamePath') === 'eloctate') {
            // Patient Path
            const correctAnswers = [
                +this.settings.hasBeenPrescribedAnswerYesIdPatientEloctate,
                +this.settings.isCommerciallyInsuredAnswerYesIdPatient,
                // +this.settings.isFederalAnswerNoIdPatient,
                this.settings.isFederalAnswerNoIdHCPQfitlia,
                +this.settings.isUSResidentAnswerYesIdPatient,
                +this.settings.isAbove18YearsOfAgeAnswerYesIdPatient,
                +this.settings.iConsentAnswerYesIdPatient,
            ] as number[];

            if (this.isMarketingOptInCheck) {
                correctAnswers.push(+this.settings.marketingOptInAnswerYesIdPatient);
                correctAnswers.push(+this.settings.marketingOptInAnswerNoIdPatient);
            }
            const isEligible = eligibilityData.every(question => question.answerId && correctAnswers.includes(question.answerId));
            this.updateIsEligible(isEligible);
            return isEligible;
        } else if (localStorage.getItem('drugNamePath') === 'altuviiio') {
            const correctAnswers = [
                +this.settings.hasBeenPrescribedAnswerYesIdPatientAltuviiio,
                +this.settings.isCommerciallyInsuredAnswerYesIdPatient,
                // +this.settings.isFederalAnswerNoIdPatient,
                this.settings.isFederalAnswerNoIdHCPQfitlia,
                +this.settings.isUSResidentAnswerYesIdPatient,
                +this.settings.isAbove18YearsOfAgeAnswerYesIdPatient,
                +this.settings.iConsentAnswerYesIdPatient,
            ] as number[];

            if (this.isMarketingOptInCheck) {
                correctAnswers.push(+this.settings.marketingOptInAnswerYesIdPatient);
                correctAnswers.push(+this.settings.marketingOptInAnswerNoIdPatient);
            }
            const isEligible = eligibilityData.every(question => question.answerId && correctAnswers.includes(question.answerId));
            this.updateIsEligible(isEligible);
            return isEligible;
        } else {
            const correctAnswers = [
                +this.settings.hasBeenPrescribedAnswerYesIdPatientAlprolix,
                +this.settings.isCommerciallyInsuredAnswerYesIdPatient,
                // +this.settings.isFederalAnswerNoIdPatient,
                this.settings.isFederalAnswerNoIdHCPQfitlia,
                +this.settings.isUSResidentAnswerYesIdPatient,
                +this.settings.isAbove18YearsOfAgeAnswerYesIdPatient,
                +this.settings.iConsentAnswerYesIdPatient,
            ] as number[];

            if (this.isMarketingOptInCheck) {
                correctAnswers.push(+this.settings.marketingOptInAnswerYesIdPatient);
                correctAnswers.push(+this.settings.marketingOptInAnswerNoIdPatient);
            }
            const isEligible = eligibilityData.every(question => question.answerId && correctAnswers.includes(question.answerId));
            this.updateIsEligible(isEligible);
            return isEligible;
        }
    }

    @Mutation
    public async updateIsMarketingOptInCheck(isMarketingOptInCheck: boolean) {
        this.isMarketingOptInCheck = isMarketingOptInCheck;
    }
}
